import { types } from "../action-types";

const initialState = {
    loading: false,
    success: false,
    error: false,
};

const updatePersonalDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.UPDATE_PERSONAL_DETAILS_REQUESTED:
            return {
                ...state,
                loading: true,
            };

        case types.UPDATE_PERSONAL_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                success:true,
                error: false,
            };
        case types.UPDATE_PERSONAL_DETAILS_FAILURE:
            return {
                ...state,
                loading: false,
                success:false,
                error: true,
            };
        default:
            return state;
    }
};
export default updatePersonalDetailsReducer;
